/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import ProjectWithAlipayDetailsComponent from './projectWithAlipay.component';

const ProjectWithAlipayModule = angular.module('tinaba.components.services.projectWithAlipay', [
    uiRouter
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.projectWithAlipay', {
        url: '/projectWithAlipay',
        template: '<project-with-alipay-details></project-with-alipay-details>'
    });
})
.component('projectWithAlipayDetails', ProjectWithAlipayDetailsComponent);

export default ProjectWithAlipayModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/projectWithAlipay/projectWithAlipay.js
 **/